// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2IOUQ","options":"AnswerScale_options__19Q1g","selected":"AnswerScale_selected__1AhXw"};